<template>
    <div class="form-item">
        <label class="label-caption">Categoria</label>
        <select :value="props.idSelecionado" @change="atualizarSelect" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsTipos" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>

<script setup>
const props = defineProps({
    idSelecionado: { type: Number, default: null }
})
const emit = defineEmits(['update:idSelecionado'])

const lsTipos = [
    { id: 1, descricao: 'PREVENTIVA' },
    { id: 2, descricao: 'CORRETIVA' },
    { id: 3, descricao: 'INSPEÇÃO' },
    { id: 4, descricao: 'DOCUMENTAL' }
]

function atualizarSelect(event) {
    emit('update:idSelecionado', Number(event.target.value))
}
</script>